import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentChargesRepository } from '../infra/ShipmentChargesRepository'

type GetShipmentAccountingSummaryFactoryDependencies = {
  repository: ShipmentChargesRepository
}

export function getShipmentAccountingSummaryFactory({
  repository,
}: GetShipmentAccountingSummaryFactoryDependencies) {
  return function getShipmentAccountingSummary(uuid: string, config?: { signal?: AbortSignal }) {
    return repository.getShipmentAccountingSummary(uuid, config)
  }
}

export function getShipmentAccountingSummary(uuid: string, config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentChargesRepository({ httpClient })
  const get = getShipmentAccountingSummaryFactory({ repository })

  return get(uuid, config)
}
